import React from 'react';
import { Badge, Card, Carousel, CustomModal, Typography, useGlobalContext } from 'seagull';
import { useIoContext, useStoreActions } from "../../../../../contexts";
import styles from "./TutorialVideos.module.scss";

const TutorialVideo = _ref => {
  let {
    video: {
      id,
      title,
      watched,
      duration
    }
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const {
    YoutubePlayer
  } = useIoContext();
  return /*#__PURE__*/React.createElement(Card, {
    className: styles.container,
    "data-testid": "tutorial-video",
    as: 'button',
    onClick: () => {
      globalContext.showModal({
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;

          const handleDismiss = () => {
            logBI(11216, {
              title
            });
            dismissModal();
          };

          return /*#__PURE__*/React.createElement(CustomModal, {
            onClose: handleDismiss,
            hideCloseBtn: true,
            "data-testid": "video-modal"
          }, /*#__PURE__*/React.createElement(YoutubePlayer, {
            playing: true,
            controls: true,
            url: "https://youtu.be/".concat(id),
            onStart: () => {
              logBI(11215, {
                title
              }); // set as watched & save, if not already watched
            },
            onEnded: handleDismiss
          }));
        },
        closeOnEscapeKey: true,
        closeOnClickOutside: true
      });
    }
  }, /*#__PURE__*/React.createElement(YoutubePlayer, {
    className: styles.thumbnail,
    light: true,
    height: 131,
    width: 232,
    url: "https://youtu.be/".concat(id)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title,
    weight: 'bold',
    ellipsis: true
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.durationRow
  }, /*#__PURE__*/React.createElement(Typography, null, "".concat(duration, " min")), watched && /*#__PURE__*/React.createElement(Badge, {
    rounded: true,
    outlined: true,
    skin: "success"
  }, "Watched"))));
};

const TutorialVideos = () => /*#__PURE__*/React.createElement(Carousel, null, [{
  id: 'ctwHVOJGqVI',
  title: 'Platform Walkthrough',
  watched: true,
  duration: '5:14'
}, {
  id: 'rOAunS9nvpU',
  title: 'Setting Up Your Account',
  watched: false,
  duration: '1:12'
}, {
  id: 'QeIUKT8F9YM',
  title: 'Setting Up Your Anchor Service Library',
  watched: true,
  duration: '5:01'
}, {
  id: 'H3j8sKUjv8U',
  title: 'Creating Proposals in Anchor',
  watched: true,
  duration: '5:50'
}, {
  id: '-wLAAwo2QyM',
  title: 'Editing an Agreement in Anchor',
  watched: false,
  duration: '2:03'
}, {
  id: 'JSg1M-Hyqho',
  title: 'Billing Hub Overview',
  watched: false,
  duration: '3:12'
}, {
  id: '0NexKPxUzsk',
  title: 'Adding Credit to Client Invoices',
  watched: true,
  duration: '0:51'
}, {
  id: 'OMn0bWYNDuA',
  title: 'Adding Charges',
  watched: false,
  duration: '1:16'
}, {
  id: 'lR4Vi-LdwEo',
  title: "Verifying a Client's Account using Micro-deposits",
  watched: false,
  duration: '0:50'
}, {
  id: 'Es4cF0f6uQY',
  title: 'Integrating QuickBooks Online with Anchor',
  watched: true,
  duration: '2:35'
}, {
  id: '7yiqP8LWZuE',
  title: 'Dashboard Overview',
  watched: true,
  duration: '1:56'
}, {
  id: '1iw0OcLIKLE',
  title: 'Updating Client Payment Methods',
  watched: true,
  duration: '0:58'
}].map(video => /*#__PURE__*/React.createElement("div", {
  key: video.id
}, /*#__PURE__*/React.createElement(TutorialVideo, {
  video: video
}))));

export default TutorialVideos;